import { useGetQueryCollection, getApiType } from 'shared/lib/api';
import { DROPDOWN_ITEMS_LIMIT } from 'shared/constants';
import { mapToOptions } from 'shared/lib/mappers';
import { SortDirection } from 'shared/ui/Sortable';
import { useMemo } from 'react';

import type { ServiceType } from '../model';

import { servicesRoutes } from './routes';

enum ListAllServicesSort {
  alias = 'sort[service][alias]',
  serviceId = 'sort[service][id]',
}

export const useGetServicesForFilters = () =>
  useGetQueryCollection<ServiceType>(servicesRoutes[getApiType()].getServices, {
    queryParams: {
      [ListAllServicesSort.alias]: SortDirection.asc,
      limit: DROPDOWN_ITEMS_LIMIT,
    },
  });

export const useGetContractorServicesForFilters = () =>
  useGetQueryCollection<ServiceType>(servicesRoutes.app.getContractorServices, {
    queryParams: {
      [ListAllServicesSort.alias]: SortDirection.asc,
      limit: DROPDOWN_ITEMS_LIMIT,
    },
  });

export function useGetServicesOptions() {
  const services = useGetServicesForFilters().data?.data;

  return useMemo(() => mapToOptions({ items: services, textField: ({ name }) => name }), [services]);
}
